import { createContext, useContext } from 'react'

import { AuthContextInterface, User } from 'features/auth/types/auth'

const initialValue: AuthContextInterface = {
  user: null,
  username: null,
  updateUsername: (username: string) => {
    void username
  },
  isAuthenticated: false,
  signIn: (user: User) => {
    void user
  },
  signOut: () => {},
  setUser: (user: User) => {
    void user
  },
  userDetails: null,
}

export const AuthContext = createContext<AuthContextInterface>(initialValue)

export const useAuthContext = (): AuthContextInterface => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuthContext must be used within a AuthContext.')
  }
  return context
}
